import { render, staticRenderFns } from "./EditUniverseModal.vue?vue&type=template&id=b28ecb4e&"
import script from "./EditUniverseModal.vue?vue&type=script&lang=js&"
export * from "./EditUniverseModal.vue?vue&type=script&lang=js&"
import style0 from "./EditUniverseModal.vue?vue&type=style&index=0&id=b28ecb4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports